import ChipMultiControl from "./ChipMultiControl"
import NumberControl from "./NumberControl"
import PhoneControl from "./PhoneControl"
import SelectControl from "./SelectControl"
import TextAreaControl from "./TextAreaControl"
import TextControl from "./TextControl"
import TextMultiControl from "./TextMultiControl"
import UploadControl from "./UploadControl"

// question.type -> its control. Every control takes the same props (see QuestionField's
// controlProps) and reads the ones it needs, so adding a type is one entry plus one file.
const CONTROLS = {
  text: TextControl,
  url: TextControl,
  textarea: TextAreaControl,
  number: NumberControl,
  phone: PhoneControl,
  select: SelectControl,
  "chip-multi": ChipMultiControl,
  "text-multi": TextMultiControl,
  upload: UploadControl
}

export default CONTROLS
